import type { CSSProperties } from 'react'
import { Radio, RadioGroup } from 'react-aria-components'
import { cx } from '../../cx'

export interface Swatch {
  id: string
  /** Accessible name — swatches have no visible text. */
  label: string
  /** The color (hex or `var(--token)`); null = a "no color" swatch, drawn struck through. */
  color: string | null
}

export interface SwatchPickerProps {
  /** Accessible name of the group (the visible label, if any, is the caller's). */
  label: string
  swatches: readonly Swatch[]
  /** The selected swatch id. */
  value: string
  onChange: (id: string) => void
  isDisabled?: boolean
  className?: string
}

/**
 * A single-choice row of color swatches: a radio group, so arrow keys move the
 * choice and each swatch is announced by its label.
 */
export function SwatchPicker({ label, swatches, value, onChange, isDisabled, className }: SwatchPickerProps) {
  return (
    <RadioGroup
      className={cx('bui-swatches', className)}
      aria-label={label}
      orientation="horizontal"
      value={value}
      onChange={onChange}
      isDisabled={isDisabled}
    >
      {swatches.map((s) => (
        <Radio
          key={s.id}
          value={s.id}
          aria-label={s.label}
          className="bui-swatch"
          data-none={s.color ? undefined : ''}
          style={s.color ? ({ '--bui-swatch': s.color } as CSSProperties) : undefined}
        />
      ))}
    </RadioGroup>
  )
}
